/**
 * The Vipupisteet view's rows (#1474, specs/workshop-modules/future_reimagined.md, "v2"): in place
 * of v1's Mittarit, which drew projected figures this line does not have (ai-honest-limits). Pure.
 *
 * Per vipupiste the locked set moves: the locked solutions that move it, which way, and their fate
 * in each scenario's course; and in how many scenarios the set still moves it its way, counting a
 * course where a solution moving it as intended is realised or delayed (carried out). A diminished
 * one only weakens it, so it is counted apart; a failed one, or none, moves nothing.
 */
const CARRIED = new Set(['realised', 'delayed']);

/**
 * @param {Array<{ id, title, type }>} vipupisteet  the shown vipupisteet, in type order
 * @param {Array<{ id, moves: Array<{ vipupisteId, direction, intent }> }>} solutions  the locked ones
 * @param {Array<{ worldId, fates: Array<{ solutionId, fate }> }>} courses  the finished courses
 * @returns {Array<{ vipupiste, movers: Array<{ solutionId, direction, intent, fates: Record<string, string|null> }>, holds: number, weakened: number, against: number, total: number }>}
 */
export function vipupisteOutcomes(vipupisteet, solutions, courses) {
  const fateIn = new Map(courses.map((c) => [c.worldId, new Map((c.fates || []).map((f) => [f.solutionId, f.fate]))]));
  return vipupisteet
    .map((vipupiste) => {
      const movers = solutions.flatMap((s) => (s.moves || [])
        .filter((m) => m.vipupisteId === vipupiste.id)
        .map((m) => ({
          solutionId: s.id,
          direction: m.direction,
          intent: m.intent,
          fates: Object.fromEntries(courses.map((c) => [c.worldId, fateIn.get(c.worldId).get(s.id) || null])),
        })));
      const inCourse = (c, test) => movers.some((m) => m.direction === 'as_intended' && test(m.fates[c.worldId]));
      const holds = courses.filter((c) => inCourse(c, (f) => CARRIED.has(f))).length;
      const weakened = courses.filter((c) => !inCourse(c, (f) => CARRIED.has(f)) && inCourse(c, (f) => f === 'diminished')).length;
      // a course where a solution moving it against its direction is carried out
      const against = courses.filter((c) => movers.some((m) => m.direction === 'against' && CARRIED.has(m.fates[c.worldId]))).length;
      return { vipupiste, movers, holds, weakened, against, total: courses.length };
    })
    .filter((row) => row.movers.length);
}
